module.exports = __webpack_public_path__ + "img/xiangmu_07.d50c0815.jpg";